import { useEffect, useRef } from "react";

const CLIENT = process.env.REACT_APP_ADSENSE_CLIENT;
const SLOT_ID = process.env.REACT_APP_ADSENSE_SLOT;

export const AdSlot = ({ slot, className = "", minH = "min-h-[90px]" }) => {
  const pushed = useRef(false);
  const live = Boolean(CLIENT && SLOT_ID);

  useEffect(() => {
    if (live && !pushed.current) {
      pushed.current = true;
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch {
        /* adsense not loaded yet */
      }
    }
  }, [live]);

  if (live) {
    return (
      <div data-testid={`ad-slot-${slot}`} aria-label="Advertisement" className={`w-full overflow-hidden ${className}`}>
        <span className="block text-center text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-400">
          Advertisement
        </span>
        <ins
          className="adsbygoogle"
          style={{ display: "block" }}
          data-ad-client={CLIENT}
          data-ad-slot={SLOT_ID}
          data-ad-format="auto"
          data-full-width-responsive="true"
        />
      </div>
    );
  }

  return (
    <div
      data-testid={`ad-slot-${slot}`}
      aria-label="Advertisement"
      className={`w-full ${minH} flex flex-col items-center justify-center gap-1 rounded-xl border border-dashed border-slate-300 bg-slate-100 text-slate-400 ${className}`}
    >
      <span className="text-[10px] font-semibold uppercase tracking-[0.2em]">Advertisement</span>
      <span className="text-xs">Google AdSense · {slot.replace(/-/g, " ")}</span>
    </div>
  );
};
